var map = {
	"./en/illustratepic_02.png": "2MtM",
	"./ja/illustratepic_02.png": "IHE5",
	"./ko/illustratepic_02.png": "MaIN",
	"./zh-CN/illustratepic_02.png": "IIfu",
	"./zh-TW/illustratepic_02.png": "D5Au"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5l8d";


//////////////////
// WEBPACK FOOTER
// ./static/images ^\.\/.*\/illustratepic_02\.png$
// module id = 5l8d
// module chunks = 1